import { combineReducers } from 'redux'
import * as actions from '../actions'
import { mapActionPayloadToState } from '../utils/reducerUtils'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isFetching: false,
  header: '',
  email: '',
  name: '',
}

const isFetching = booleanReducer({
  defaultState: initialState.isFetching,
  trueTypes: [actions.GET_AUTH_REQUEST],
  falseTypes: [actions.GET_AUTH_SUCCESS, actions.GET_AUTH_FAILURE],
})

const header = (state = initialState.header, { type, meta }) =>
  type === actions.SET_AUTH_HEADER ? meta : state

const authSuccessProps = mapActionPayloadToState(
  initialState,
  actions.GET_AUTH_SUCCESS,
  ['email', 'name'],
)

export default combineReducers({
  isFetching,
  header,
  ...authSuccessProps,
})



// WEBPACK FOOTER //
// ./src/reducers/auth.js